<template>
  <v-card-text
    v-bind="{...defaults, ...$attrs}"
    class="ol-card__text px-xs-only-2"
    v-on="$listeners"
  >
    <template
      v-for="(_, slot) of $scopedSlots"
      #[slot]="scope"
    >
      <slot
        :name="slot"
        v-bind="scope"
      />
    </template>
    <slot />
  </v-card-text>
</template>

<script>
export default {
  name: 'OlCardText',
  inheritAttrs: false,
  beforeCreate() {
    this.defaults = {

    }
  }
}
</script>
